/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/naming-convention */
export enum MessageResult {
  OkPressed,
  ClosePressed
}
